import { useNavigate } from "@tanstack/react-router";

import { CaseSchema } from "@api/generated/types.gen";

import { CasesList } from "@components/CasesList";
import { CreateCaseAction } from "@components/CasesList/components/CreateCaseAction";
import { PageHeader } from "@components/PageHeader";
import { RecordingNavWarningModal } from "@components/RecordingDock/RecordingNavWarningModal";

import { NAVIGATION_PATHS } from "@constants/navigation";

import { useNavigationWarning } from "@hooks/useNavigationWarning";

const ReportStudioPage = () => {
  const navigate = useNavigate();
  const {
    handleNavigationWithWarning,
    showWarningModal,
    isRecordingWarning,
    recordingExamineeName,
    handleConfirmNavigation,
    handleCancelNavigation,
  } = useNavigationWarning();

  const handleRowClick = (caseItem: CaseSchema) => {
    const path = `${NAVIGATION_PATHS.REPORT_STUDIO}/${caseItem.case_number}`;
    handleNavigationWithWarning(() => navigate({ to: path }), path);
  };

  return (
    <div className="space-y-2 p-2 pl-0">
      <div className="rounded-2xl border border-foreground-muted/20 bg-background-white p-4">
        <PageHeader
          title="Report Studio"
          description="Every case you are working on, in one place."
          rightContent={<CreateCaseAction />}
        />
      </div>

      <CasesList onRowClick={handleRowClick} />

      {/* This page's pathname never contains "/preview", so
          useNavigationWarning's unsaved-report-edits branch can never fire
          here — only the recording guard is relevant on this route. */}
      <RecordingNavWarningModal
        isOpen={showWarningModal && isRecordingWarning}
        examineeName={recordingExamineeName}
        onStay={handleCancelNavigation}
        onFinishAndLeave={handleConfirmNavigation}
      />
    </div>
  );
};

export default ReportStudioPage;
